module.exports = __webpack_public_path__ + "img/5.1d49f5e3.svg";